<template lang="pug">
    div(v-if="renderBanner && isJustR" class="flex items-center overflow-hidden")
        img(
            src="@/assets/common/the-r.svg"
            alt=""
            width="28"
            height="26"
        )
    img(
        v-else-if="renderBanner"
        src="@/assets/common/madeByRBadge.svg"
        alt="Made By RealTruck"
        width="101"
        height="24"
    )
</template>

<script>
export default {
    name: 'MadeByRealtruck',
    props: {
        isJustR: {
            type: Boolean,
            default: false,
        },
        brand: {
            type: String,
            default: null,
        },
    },
    computed: {
        renderBanner() {
            if (!this.brand) return false

            return !!(
                this.$sitewideData.config.madeByRealTruckBrands?.data.includes(this.brand) ||
                this.$sitewideData.config.madeByRealTruckOnlineOnlyBrands?.data.includes(this.brand)
            )
        },
    },
}
</script>
